import React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function AgentHubSelect<Value extends string | number>({
  label,
  value,
  choices,
  onChange,
}: {
  label: string;
  value: Value;
  choices: ReadonlyArray<{ value: Value; label: string }>;
  onChange: (value: Value) => void;
}) {
  return (
    <FormControl size="small" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value}
        onChange={(event) =>
          onChange(choices.find((choice) => String(choice.value) === String(event.target.value)).value)
        }
      >
        {choices.map((choice) => (
          <MenuItem key={choice.value} value={choice.value}>
            {choice.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
